import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output, Text } from "@components/Reference";
import Sandbox from "@components/Sandbox";
import { Spacer } from "@cleartrip/bento/lib";
import { Table, TRow, TCol } from '@components/Table';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "position"
    }}>{`Position`}</h1>
    <p>{`Sets how the element is positioned in the DOM`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.p-static</Name>
    <Output mdxType="Output">position: static;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.p-relative</Name>
    <Output mdxType="Output">position: relative;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.p-absolute</Name>
    <Output mdxType="Output">position: absolute;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.p-fixed</Name>
    <Output mdxType="Output">position: fixed;</Output>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.p-sticky</Name>
    <Output mdxType="Output">position: sticky;</Output>
  </Property>
    </Reference>
    <h2 {...{
      "id": "abbreviation"
    }}>{`Abbreviation`}</h2>
    <Table mdxType="Table">
  <TRow className="flex flex-between p-3 bg-grey-05 c-pointer" mdxType="TRow">
    <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
        Abbreviation
    </TCol>
    <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
        Definition
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        t
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        top
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        r
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        right
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        b
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        bottom
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        l
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        left
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        nt
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        negative top
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        nr
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        negative right
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        nb
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        negative bottom
    </TCol>
  </TRow>
  <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        nl
    </TCol>
    <TCol className="flex-1 flex flex-start" mdxType="TCol">
        negative left
    </TCol>
  </TRow>
    </Table>
    <h2 {...{
      "id": "example"
    }}>{`Example`}</h2>
    <Sandbox mdxType="Sandbox">
    <Sandbox.Preview>
        <div className="p-relative o-scroll" style={{
          "height": "120px"
        }}>
            <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-static">static</div>
            <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-relative t-5 l-10" style={{
            "height": "150px"
          }}>relative</div>
            <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-absolute t-12 r-15">absolute</div>
            <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-sticky t-15">sticky</div>
        </div>
    </Sandbox.Preview>
    <Sandbox.Code>
      <div className="p-static">...</div>
      <div className="p-relative t-5 l-10">...</div>
      <div className="p-absolute t-12 r-15">...</div>
      <div className="p-sticky t-15">...</div>
    </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "positive-coordinates"
    }}>{`Positive coordinates`}</h2>
    <Table mdxType="Table">
      <TRow className="flex flex-between p-3 bg-grey-05 c-pointer" mdxType="TRow">
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            Prefix
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            0px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            4px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            8px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            12px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            16px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            20px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            24px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            28px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            80px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            t
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .t-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            r
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .r-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            b
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .b-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            l
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .l-20
        </TCol>
    </TRow>
    </Table>
    <h2 {...{
      "id": "negative-coordinates"
    }}>{`Negative coordinates`}</h2>
    <Table mdxType="Table">
      <TRow className="flex flex-between p-3 bg-grey-05 c-pointer" mdxType="TRow">
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            Prefix
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            0px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            4px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            8px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            12px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            16px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            20px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            24px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            28px
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            80px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            nt
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nt-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            nr
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nr-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            nb
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nb-20
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" style={{
        "borderBottom": "1px solid #e1e1e1"
      }} mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            nl
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-0
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-1
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-4
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-5
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-6
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-7
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            ...
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            .nl-20
        </TCol>
    </TRow>
    </Table>
    <Spacer my={4} mdxType="Spacer" />
    <h2 {...{
      "id": "example-1"
    }}>{`Example`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block ta-center oy-scroll p-relative" style={{
          height: '250px',
          width: '600px'
        }}>
      <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-absolute b-1 r-5">.b-1 .r-5</div>  
      <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-absolute t-5 r-15">.t-5 .r-15</div>  
      <div className="w-10p d-inline-block bg-tertiary-300 ba bc-tertiary-700 h-56 c-black fs-caption ta-center z-0 p-absolute t-10 l-12">.t-10 .l-12</div>  
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="p-absolute b-1 r-5"></div>
    <div className="p-absolute t-5 r-15"></div>
    <div className="p-absolute t-10 l-12"></div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      